import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('jnaft_token');
    if (token) {
      authAPI.getMe()
        .then(({ data }) => setUser(data.user))
        .catch(() => {
          localStorage.removeItem('jnaft_token');
          localStorage.removeItem('jnaft_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('jnaft_token', data.token);
    localStorage.setItem('jnaft_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('jnaft_token');
    localStorage.removeItem('jnaft_user');
    setUser(null);
  }, []);

  const isAdmin = user && user.role !== 'viewer';
  const isSuperAdmin = user?.role === 'super_admin';
  const can = (module) => {
    if (!user) return false;
    if (user.role === 'super_admin') return true;
    const perms = {
      content_admin: ['events','azkar','quotes','announcements','library','islamiyah'],
      media_admin:   ['gallery','sawia','library','islamiyah'],
      radio_admin:   ['radio','events'],
    };
    return perms[user.role]?.includes(module) || false;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isSuperAdmin, can }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
